
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import AssetMixin from "../../../../../mixin/AssetMixin";
import { ModalID } from "@/enums/ModalID";
import ActionButton from "@/pages/shared/components/buttons/ActionButton.vue";
import { ActionID } from "@/enums/ActionID";

@Component({
  components: { ActionButton },
})
export default class NewSecurityAction extends mixins(Vue, AssetMixin) {
  id = ActionID.ADD_SECURITY;

  openModal(): void {
    Vue.prototype.$modal.show(ModalID.NEW_SECURITY);
  }
}
